function controller (myAlertsService, saveVehicleService, pageStateService) {
    let ctrl = this;

    ctrl.emailFormat = /^\S+@[^-.][a-zA-Z0-9-]+\.{1}[^\.][a-zA-Z.]+$/;

    ctrl.optout = function () {
        myAlertsService.setOptoutState();
    };

    ctrl.submit = function (formEmail) {

        ctrl.alertSubmitted = myAlertsService.isAlertSubmitted();

        if (formEmail) {
            saveVehicleService.setEmail(formEmail);
            saveVehicleService.myAlertsCreateTracker();
              pageStateService.push('event', {
                  eventName: "custom-link",
                  linkName: "create-alert-save-vehicle"
              }, true);
            ctrl.alertSubmitted = true;
        }
    };
}
controller.$inject = ['myAlertsService', 'saveVehicleService', 'pageStateService'];

export default controller;
